import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "total-outers-container" }
const _hoisted_2 = { class: "main-container-unexpanded" }
const _hoisted_3 = { class: "text-container" }
const _hoisted_4 = { class: "main-text" }
const _hoisted_5 = { class: "topic-text" }
const _hoisted_6 = { class: "arrow-container" }
const _hoisted_7 = {
  key: 0,
  class: "main-container-expanded-content"
}
const _hoisted_8 = { class: "top-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.main_text), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.expanded == true)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args))),
              width: "17",
              height: "18",
              viewBox: "0 0 17 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("path", {
                d: "M1.93942 0.832753C1.49575 0.389082 0.77642 0.389082 0.332751 0.832753C-0.110917 1.27642 -0.110917 1.99575 0.332751 2.43942L6.89334 9.00003L0.332819 15.5606C-0.110849 16.0042 -0.110849 16.7236 0.332819 17.1672C0.776487 17.6109 1.49582 17.6109 1.93948 17.1672L8.5 10.6067L15.0605 17.1672C15.5042 17.6109 16.2235 17.6109 16.6672 17.1672C17.1109 16.7236 17.1109 16.0042 16.6672 15.5606L10.1067 9.00003L16.6672 2.43942C17.1109 1.99575 17.1109 1.27642 16.6672 0.832753C16.2236 0.389082 15.5043 0.389082 15.0606 0.832753L8.5 7.39336L1.93942 0.832753Z",
                fill: "#0F172A",
                "fill-opacity": "0.7"
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.expanded == false)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args))),
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("path", {
                d: "M13.1566 1.58323C13.1566 0.955786 12.6479 0.447144 12.0205 0.447145C11.3931 0.447146 10.8844 0.95579 10.8844 1.58323L10.8844 10.8613L1.60641 10.8613C0.978969 10.8613 0.470324 11.37 0.470323 11.9974C0.470321 12.6249 0.978964 13.1335 1.60641 13.1335L10.8844 13.1335L10.8844 22.4115C10.8844 23.0389 11.393 23.5476 12.0205 23.5476C12.6479 23.5476 13.1565 23.0389 13.1565 22.4115L13.1566 13.1335L22.4347 13.1335C23.0621 13.1335 23.5707 12.6248 23.5707 11.9974C23.5707 11.3699 23.0621 10.8613 22.4347 10.8613L13.1566 10.8613L13.1566 1.58323Z",
                fill: "#0F172A",
                "fill-opacity": "0.7"
              }, null, -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.expanded == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.text_expanded), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}